import { Storybook } from "@tento-ui/ui/storybook";
import { DshTermBlock } from "./term-block";

export class DshTermBlockStoryBook extends Storybook.Default {
  title(): string {
    return "Turn dsh · term-block";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "The fixture's block — rust",
        render: () =>
          DshTermBlock.makeWith({
            language: "rust",
            text: "fn lane_clock(lane: &Lane) -> Vec<i64> {\n"
              + "    let mut last = 0;\n"
              + "    lane.records.iter().map(|r| { last = r.at.max(last); last }).collect()\n"
              + "}",
          }),
      },
      {
        title: "Lisp — the highlighting the palette already defines",
        render: () =>
          DshTermBlock.makeWith({
            language: "lisp",
            text: [
              '; Lazy agent lanes: advertised in the Shift-Tab cycle immediately.',
              '(lane.declare "opencode")',
              '(lane.declare "lead" :handler "deepseek" :permissions :allow-workspace)',
              '(prompt.use prompt.global)',
            ].join("\n"),
          }),
      },
      {
        title: "Plain — the default, because output is text until told otherwise",
        render: () =>
          DshTermBlock.makeWith({
            text: [
              "perfile: emitted 162 modules, 1 roots → target.web.modules",
              "  @m/.../html/routes/index.root → /js/m/.../index.root.b796b9e0.js",
              "  skip routes/index.html (no bundled HTML)",
            ].join("\n"),
          }),
      },
      {
        title: "A single line",
        render: () =>
          DshTermBlock.makeWith({ text: "cargo build -p tento-spool-server" }),
      },
      {
        title: "Past 224px — the block scrolls, not the column",
        render: () =>
          DshTermBlock.makeWith({
            text: [
              "   Compiling tento-pane-runtime v0.1.0 (/Users/james/workspace/tento/tento-pane-runtime)",
              "warning: unused variable: `lane_id` --> tento-pane-runtime/src/dispatch.rs:412:23",
              "    Finished `test` profile [unoptimized + debuginfo] target(s) in 41.62s",
              "     Running unittests src/lib.rs (/Users/james/ssd-mount/cargo-target/debug/deps/tento_pane_runtime-9f2c1ab4e7d60358)",
              "running 212 tests",
              "test dispatch::tests::a_dropped_lane_settles_its_open_turn ... ok",
              "test dispatch::tests::records_interleave_by_clock_not_by_seq ... ok",
              "test queue::tests::a_queued_unit_survives_a_restart ... ok",
              "test queue::tests::a_restarted_unit_keeps_its_lane ... ok",
              "test render::tests::a_row_measures_itself_after_the_frame ... ok",
              "test render::tests::a_folded_batch_reports_its_own_height ... ok",
              "test result: ok. 212 passed; 0 failed; 0 ignored; 0 measured; 0 filtered out; finished in 2.41s",
            ].join("\n"),
          }),
      },
      {
        title: "Empty",
        render: () => DshTermBlock.makeWith({ text: "" }),
      },
    ];
  }
}
